// @flow
import {
    ACQUIRE_DEVICES,
    CLOSE_PLACEMENT_ADVICE,
    FINISH_INSTALL_DEVICES,
    FINISHED_INSTALL_DEVICES,
    LOAD_INSTALL_DEVICES,
    START_ACQUIRE_DEVICES,
    STOP_ACQUIRE_DEVICES,
    UNLOAD_INSTALL_DEVICES
} from './constants';

import { createAction } from 'redux-actions';

export const acquireDevices = createAction(ACQUIRE_DEVICES);
export const closePlacementAdvice = createAction(CLOSE_PLACEMENT_ADVICE);
export const finishInstallDevices = createAction(FINISH_INSTALL_DEVICES);
export const finishedInstallDevices = createAction(FINISHED_INSTALL_DEVICES);
export const loadInstallDevices = createAction(LOAD_INSTALL_DEVICES);
export const startAcquireDevices = createAction(START_ACQUIRE_DEVICES, () => new Date());
export const stopAcquireDevices = createAction(STOP_ACQUIRE_DEVICES);
export const unloadInstallDevices = createAction(UNLOAD_INSTALL_DEVICES);



// WEBPACK FOOTER //
// ./src/core/state/acquire-devices/actions.js